import React, { FC } from 'react'
import { Layout } from 'components/Layout'
import { CampaignEditTemplate } from 'components/Templates'
import { useSelector } from 'react-redux'
import { State } from 'index'
import { db } from 'firebase/index'

const CampaignEdit: FC = () => {
  const path = useSelector((state: State) => state.router.location.pathname)
  const isCreatePage = /\/admin\/campaign_cms\/create/.test(path)
  const isValidPath = /\/admin\/campaign_cms\/.+/.test(path)
  const id = isCreatePage
    ? db.collection('campaigns').doc().id // 画像アップロードフォルダパスのために先にIDを生成しておく
    : isValidPath
    ? path.split('/admin/campaign_cms/')[1]
    : ''
  return (
    <Layout headline={'キャンペーン'} iconPath={'/icon/white/cms.svg'} title={'キャンペーンの編集'}>
      <CampaignEditTemplate id={id} isCreatePage={isCreatePage} />
    </Layout>
  )
}

export default CampaignEdit
